class YaCounter {
	constructor() {}

	goal(goal) {
		console.log('init goal: ' + goal);
		if (typeof window['yaCounter'+App.ymId] !== 'undefined') {
			console.log('Worked goal: ' + goal);
			window['yaCounter'+App.ymId].reachGoal(goal);
		}
	}

	hits (hit) {
		hit = hit || location.href;

		console.log('init hit: ' + hit);
		if (typeof window['yaCounter'+App.ymId] !== 'undefined') {
			console.log('Worked hit: ' + hit);
			window['yaCounter'+App.ymId].hit(hit);
		}
	}
}

export default YaCounter;
